module.exports = __webpack_public_path__ + "b97cbe7fde554a1980a1449700fe289f.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Bold-Oblique.ttf
// module id = 391
// module chunks = 0